import React, { Component } from 'react';

export default class BgImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageStatus: false,
      imgStyle: null
    };
    this.bgSize = null;
    if (this.props.bgSize == 'contain') {
      this.bgSize = 'contain ';
    } else {
      this.bgSize = '';
    }
    this.theClasses = 'bg-image ' + this.bgSize + ' ';
    this.updateImageBg = this.updateImageBg.bind(this);
    this.style1 = {
      opacity: 0
    };
  }

  updateImageBg(p){
    let img = p.source;
    let Bg = 'url(' + img + ')';
    this.setState({
      imgStyle: {
        backgroundImage: Bg,
        opacity: 1
      }
    });
  }

  handleImageLoaded() {
    const t = this;
    this.setState({ imageStatus: true });
    if (this.props.isLoaded) {
      t.props.isLoaded();      
    }
  }
  handleImageErrored() {
    this.setState({ imageStatus: false });
  }
  componentDidMount() {
    this.updateImageBg(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.updateImageBg(nextProps);
  }
  render() {
    return (
      <div style={this.state.imageStatus ? this.state.imgStyle : this.style1} className={(this.state.imageStatus) ? this.theClasses + 'loaded' : this.theClasses + 'loading'}>
        <img
            src={this.props.source}
            onLoad={this.handleImageLoaded.bind(this)}
            onError={this.handleImageErrored.bind(this)}
        />
      <style jsx>{`
        .bg-image {
          width: 100%;
          height: 100%;
          transition: all 1500ms ease;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          transform: translate3d(0,0,0);
          display: block;
          backface-visibility: hidden;
          opacity: 0;
          position: relative;
        }
        .bg-image.contain {
          background-size: contain;
        }
        img {
          width: 0;
          height: 0;
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 0;
        }
      `}</style>
    </div>
  );
  }
};



// WEBPACK FOOTER //
// ./src/components/dom-elements/BgImage.js